import React, { useCallback } from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { IEditField } from './formTools';
import { EditDate, EditDateField } from './EditDate';

export const EditCompletedAtDateDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task, setIsEditing }) => (
  <EditDate task={task} setIsEditing={setIsEditing} fieldName="completedAt" />
);

export const EditCompletedAtDateField: React.FC<IEditField> = ({ submitOnChange, cancel }) => {
  const disableDate = useCallback((date: Date) => date > new Date(), []);
  return (
    <EditDateField submitOnChange={submitOnChange} fieldName="completedAt" disableDates={disableDate} cancel={cancel} />
  );
};
